<div class="settings-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12 settings-page__content">
                <div class="settings-card">
                    <div class="settings-card__header">
                        <img src="/assets/images/Group 24.svg" alt="" />
                        <div class="settings-card__header-headline">
                            <h4>Borderou - Documente</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Borderou</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1" (click)="refresh()">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button *ngIf="permissionsService.hasPermission('indoc-module.borderouri.add')"
                                type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
                                <i class="fa-solid fa-plus"></i>
                                Adaugă
                            </button>
                        </div>
                    </div>

                    <div class="card-container request-filter p-2" *ngIf="showCard">
                        <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="divider-container">
                                        <div class="line"></div>
                                        <span class="text">ORIGINE/OPERATOR</span>
                                        <div class="line"></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Instituție/Direcție</mat-label>
                                                <input matInput [formControl]="directiiOriginControl"
                                                    [matAutocomplete]="autoDirectiiOrigin"
                                                    (blur)="onDirectiiOriginBlur()" />
                                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                                <mat-autocomplete #autoDirectiiOrigin="matAutocomplete"
                                                    [displayWith]="displayDirectiiOrigin"
                                                    (optionSelected)="onDirectiiOriginChange($event.option.value)">
                                                    <mat-option *ngIf="filteredDirectiiOrigin.length === 0" disabled>
                                                        Nu au fost găsite rezultate
                                                    </mat-option>
                                                    <mat-option *ngFor="let directie of filteredDirectiiOrigin"
                                                        [value]="directie">
                                                        {{ directie.name }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Compartiment/Departament</mat-label>
                                                <input matInput [formControl]="compartimenteOriginControl"
                                                    [matAutocomplete]="autoCompartimenteOrigin"
                                                    (blur)="onCompartimenteOriginBlur()" />
                                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                                <mat-autocomplete #autoCompartimenteOrigin="matAutocomplete"
                                                    [displayWith]="displayCompartimenteOrigin"
                                                    (optionSelected)="onCompartimenteOriginSelected($event.option.value)">
                                                    <mat-option *ngIf="showCompartimenteOriginMessage" disabled>
                                                        <span
                                                            *ngIf="!compartimenteOriginControl.value || compartimenteOriginControl.value.length < 2">
                                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                                        </span>
                                                        <span
                                                            *ngIf="isCompartimenteOriginLoading && compartimenteOriginControl.value && compartimenteOriginControl.value.length >= 2">Căutare...</span>
                                                        <span
                                                            *ngIf="!isCompartimenteOriginLoading && compartimenteOriginLoadComplete && compartimenteOrigin.length === 0 && compartimenteOriginControl.value && compartimenteOriginControl.value.length >= 2">
                                                            Nu au fost găsite rezultate
                                                        </span>
                                                    </mat-option>

                                                    <mat-option *ngFor="let compartiment of compartimenteOrigin"
                                                        [value]="compartiment">
                                                        {{ compartiment.name }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Operator</mat-label>
                                                <mat-select formControlName="origin_user_id">
                                                    <mat-option [value]="-1">-- Alegeți --</mat-option>
                                                    <mat-option *ngFor="let operator of filteredOperatoriOrigin"
                                                        [value]="operator.id">
                                                        {{ operator.name }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="divider-container">
                                        <div class="line"></div>
                                        <span class="text">DESTINAȚIE</span>
                                        <div class="line"></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Instituție/Direcție</mat-label>
                                                <input matInput [formControl]="directiiDestinatieControl"
                                                    [matAutocomplete]="autoDirectiiDestinatie"
                                                    (blur)="onDirectiiDestinatieBlur()" />
                                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                                <mat-autocomplete #autoDirectiiDestinatie="matAutocomplete"
                                                    [displayWith]="displayDirectiiDestinatie"
                                                    (optionSelected)="onDirectiiDestinatieChange($event.option.value)">
                                                    <mat-option *ngIf="filteredDirectiiDestinatie.length === 0"
                                                        disabled>
                                                        Nu au fost găsite rezultate
                                                    </mat-option>
                                                    <mat-option *ngFor="let directie of filteredDirectiiDestinatie"
                                                        [value]="directie">
                                                        {{ directie.name }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Compartiment/Departament</mat-label>
                                                <input matInput [formControl]="compartimenteDestinatieControl"
                                                    [matAutocomplete]="autoCompartimenteDestinatie"
                                                    (blur)="onCompartimenteDestinatieBlur()" />
                                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                                <mat-autocomplete #autoCompartimenteDestinatie="matAutocomplete"
                                                    [displayWith]="displayCompartimenteDestinatie"
                                                    (optionSelected)="onCompartimenteDestinatieSelected($event.option.value)">
                                                    <mat-option *ngIf="showCompartimenteDestinatieMessage" disabled>
                                                        <span
                                                            *ngIf="!compartimenteDestinatieControl.value || compartimenteDestinatieControl.value.length < 2">
                                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                                        </span>
                                                        <span
                                                            *ngIf="isCompartimenteDestinatieLoading && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">Căutare...</span>
                                                        <span
                                                            *ngIf="!isCompartimenteDestinatieLoading && compartimenteDestinatieLoadComplete && compartimenteDestinatie.length === 0 && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">
                                                            Nu au fost găsite rezultate
                                                        </span>
                                                    </mat-option>

                                                    <mat-option *ngFor="let compartiment of compartimenteDestinatie"
                                                        [value]="compartiment">
                                                        {{ compartiment.name }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Operator</mat-label>
                                                <mat-select formControlName="destinatie_user_id">
                                                    <mat-option [value]="-1">-- Alegeți --</mat-option>
                                                    <mat-option *ngFor="let operator of filteredOperatoriDestinatie"
                                                        [value]="operator.id">
                                                        {{ operator.name }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="divider-container">
                                <div class="line"></div>
                                <span class="text">IDENTIFICARE DOCUMENT(E)</span>
                                <div class="line"></div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <mat-form-field>
                                        <mat-label>Număr Document(Intrare/Intern)</mat-label>
                                        <input matInput type="number" formControlName="document_number" />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Dată Document(e) de la:</mat-label>
                                        <input matInput [max]="today" [matDatepicker]="dateInputStartPicker"
                                            formControlName="date_input_start" readonly
                                            (focus)="dateInputStartPicker.open()" />
                                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="dateInputStartPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #dateInputStartPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Dată Document(e) până la:</mat-label>
                                        <input matInput [min]="today" [matDatepicker]="dateInputEndPicker"
                                            formControlName="date_input_end" readonly
                                            (focus)="dateInputEndPicker.open()" />
                                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="dateInputEndPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #dateInputEndPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col d-flex justify-content-start">
                                    <button (click)="toggleCard()" type="button"
                                        class="btn btn-sm btn-warning closeBtn">
                                        Închide
                                    </button>
                                </div>
                                <div class="col buttons-submit">
                                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                        Resetează
                                    </button>
                                    <button type="submit" class="btn btn-sm btn-primary ms-2">
                                        Aplică
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                    </div>

                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start">
                            <button *ngIf="permissionsService.hasPermission('indoc-module.borderouri.show_filters')"
                                class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="Filtrare" />
                                <span>Filtre</span>
                            </button>
                        </div>
                    </div>
                    <div class="table-container">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100">
                        </table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>